import * as React from 'react';

import {
  PROMPTS_DISPLAY_LIMIT_LOHP_PILLS,
  PROMPTS_FETCH_LIMIT_LOHP_ZERO_STATE,
} from 'bundles/search-common/constants/autocomplete';
import { useAiSearchExperimentData } from 'bundles/search-common/providers/AiSearchExperimentProvider';
import QueryPromptsProvider from 'bundles/search-common/providers/QueryPromptsProvider';

const FrontPageQueryPromptsProvider = ({ children }: React.PropsWithChildren) => {
  const { isVariant2 } = useAiSearchExperimentData();

  return (
    // Make sure to fetch the prompt pills during CSR
    <QueryPromptsProvider
      skip={!isVariant2}
      fetchLimit={PROMPTS_FETCH_LIMIT_LOHP_ZERO_STATE}
      displayLimit={PROMPTS_DISPLAY_LIMIT_LOHP_PILLS}
    >
      {children}
    </QueryPromptsProvider>
  );
};

export default FrontPageQueryPromptsProvider;
